module.exports = [{
      plugin: require('/home/spoton/edgar/tlahtolli-site/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/spoton/edgar/tlahtolli-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
